import { FIELDS } from '../form-fields/enum';

const { VIDEO_TITLE, CHANNEL_SELECT, KEYWORDS, DESCRIPTION, LANGUAGE_SELECT, COUNTRY_SELECT } = FIELDS;

export const mergeChannelSelectKeys = (formData) =>
  Object.keys(formData)
    .filter((key) => key.includes(FIELDS.CHANNEL_SELECT))
    .reduce((prev, current) => {
      return prev.concat(formData[current]);
    }, []);

/**
 * @param {*[]} formConfig
 * @param {*} formData
 * @param {string} videoId
 * @return {*}
 */
export const videoFormTransform = (formConfig, formData, videoId) => {
  let data = {
    videoId,
    [VIDEO_TITLE]: formData[VIDEO_TITLE],
    [CHANNEL_SELECT]: [],
    [KEYWORDS]: [],
    [DESCRIPTION]: formData[DESCRIPTION] || '',
  };

  formConfig.forEach((config) => {
    if (config.type === KEYWORDS) {
      data[KEYWORDS] = formData[KEYWORDS];
    }

    if (config.type === LANGUAGE_SELECT) {
      data[LANGUAGE_SELECT] = formData[LANGUAGE_SELECT] || null;
    }

    if (config.type === COUNTRY_SELECT) {
      data[COUNTRY_SELECT] = formData[COUNTRY_SELECT] || null;
    }

    // collect and merge all values for type of CHANNEL_SELECT only once
    if (config.type === CHANNEL_SELECT && data[CHANNEL_SELECT].length === 0) {
      data[CHANNEL_SELECT] = mergeChannelSelectKeys(formData);
    }

    // collect and merge all values for type of CHANNEL_SELECT only once
    if (config.type === CHANNEL_SELECT && data[CHANNEL_SELECT].length === 0) {
      data[CHANNEL_SELECT] = mergeChannelSelectKeys(formData);
    }
  });

  //TODO create view-model
  return {
    ...formData,
    ...data,
  };
};
